export default "__VITE_ASSET__DAXqv1oW__"